import React from 'react';
import { useNavigate } from 'react-router-dom';
import NormalHeader from '../components/NormalHeader';
import NormalFooter from '../components/NormalFooter';

const NormalEntry: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <NormalHeader />
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 sm:px-6">
        <div className="rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-100 sm:p-10">
          <p className="text-sm font-semibold text-brand-primary">Normal Flow</p>
          <h1 className="mt-2 text-2xl font-bold text-gray-900">UI非依存の予約フォーム</h1>
          <p className="mt-2 text-sm text-gray-600">
            こちらのフローは Tailwind ベースのシンプルなUIで、MUIに依存しない構成です。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              onClick={() => navigate('/form/normal/form1')}
              className="inline-flex items-center justify-center rounded-lg bg-brand-primary px-4 py-2 text-sm font-semibold text-white shadow hover:bg-green-600"
            >
              予約をはじめる
            </button>
            <button
              onClick={() => navigate('/form/normal/reservations')}
              className="inline-flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50"
            >
              予約一覧を見る
            </button>
          </div>
        </div>
      </main>
      <NormalFooter />
    </div>
  );
};

export default NormalEntry;
